import React from "react";
import { func, string } from "prop-types";

import { slpIcon } from "../../assets";
import * as S from "./styled";

const SellerLandingCTA = ({ handleCloseClick, handleLinkClick, href }) => (
  <>
    <S.Container>
      <S.SellerLandingIcon alt="" srcSet={slpIcon} />
      <S.Content>
        Explore selling further by visiting your Owner Dashboard. It’s a hub for
        tools, guides, and meeting more agents.
      </S.Content>
      <S.DashboardButton href={href} onClick={handleLinkClick} target="_blank">
        Visit Owner Dashboard
      </S.DashboardButton>
      <S.CloseButton onClick={handleCloseClick}>Close</S.CloseButton>
    </S.Container>
  </>
);

SellerLandingCTA.propTypes = {
  handleCloseClick: func.isRequired,
  handleLinkClick: func,
  href: string.isRequired
};

SellerLandingCTA.defaultProps = {
  handleLinkClick: () => {}
};

export default SellerLandingCTA;
